import React from 'react';
import Amatista from './Img/piletaschicas/Amatista.png';
import AmatistaIlustracion from './Img/piletaschicas/AmatistaIlustracion.png';
import AguaMarina from './Img/piletaschicas/AguaMarina.png';
import AguaMarinalustracion from './Img/piletaschicas/AguaMarinaIlustracion.png';
import Turquesa from './Img/piletaschicas/Turquesa.png';
import TurquesaIlustracion from './Img/piletaschicas/TurquesaIlustracion.png';
import Kriptonita from './Img/piletaschicas/Kriptonita.png';
import KriptonitaIlustracion from './Img/piletaschicas/KriptonitaIlustracion.png';
import Turmalina from './Img/piletaschicas/Turmalina.png';
import TurmalinaIlustracion from './Img/piletaschicas/TurmalinaIlustracion.png';
import GemaAzulIlustracion from './Img/piletaschicas/GemaAzulIlustracion.jpg';
import OpaloIlustracion from './Img/piletaschicas/OpaloIlustracion.png';
import CoralIlustracion from './Img/piletaschicas/CoralIlustracion.png';
import PerlaIlustracion from './Img/piletaschicas/PerlaIlustracion.png';




function ModelosMedianos() {
  return (
    <>
      <br /><br /><br />
      <div class="mt-5 w-100">
        <div class="row m-1">

          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Amatista</h4>
              <img src={Amatista} class="card-img-top px-3" alt="Amatista" />
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 6,50 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,10 m</div>
                  <div class="card ps-2">Profundidad: 1,45 a 1,60 m</div>
                  <div class="card border-0 ps-2">Volumen: 19.980 L</div>
                </div>
              </div>
              <div>
                <img src={AmatistaIlustracion} class="card-img-top" alt="Amatista Ilustración" />
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Agua Marina</h4>
              <img src={AguaMarina} class="card-img-top px-3" alt="Agua Marina" />
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,30 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,50 m</div>
                  <div class="card ps-2">Profundidad: 1,45 a 1,60 m</div>
                  <div class="card border-0 ps-2">Volumen: 26.750 L</div>
                </div>
              </div>
              <div>
                <img src={AguaMarinalustracion} class="card-img-top" alt="Agua Marina Ilustración" />
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Turquesa</h4>
              <img src={Turquesa} class="card-img-top px-3" alt="Turquesa" />
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 6,50 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,10 m</div>
                  <div class="card ps-2">Profundidad: 1,30 a 1,60 m</div>
                  <div class="card border-0 ps-2">Volumen: 19.860 L</div>
                </div>
              </div>
              <div>
                <img src={TurquesaIlustracion} class="card-img-top" alt="Turquesa Ilustración" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 w-100">
        <div class="row m-1">

          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Kriptonita</h4>
              <img src={Kriptonita} class="card-img-top px-3" alt="Kriptonita" />
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 6,0 m</div>
                  <div class="card border-0 ps-2">Ancho: 2,90 m</div>
                  <div class="card ps-2">Profundidad: 1,3 m</div>
                  <div class="card border-0 ps-2">Volumen: 15.120 L</div>
                </div>
              </div>
              <div>
                <img src={KriptonitaIlustracion} class="card-img-top" alt="Kriptonita Ilustración" />
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Turmalina</h4>
              <img src={Turmalina} class="card-img-top px-3" alt="Turmalina" />
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,30 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,50 m</div>
                  <div class="card ps-2">Profundidad: 1,40 a 1,60 m</div>
                  <div class="card border-0 ps-2">Volumen: 27.300 L</div>
                </div>
              </div>
              <div>
                <img src={TurmalinaIlustracion} class="card-img-top" alt="Turmalina Ilustración" />
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Perla</h4>
              {/*<img src={Agata} class="card-img-top px-3" alt="Ágata" />*/}
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,00 m</div>
                  <div class="card border-0 ps-2">Ancho: 2,50 m</div>
                  <div class="card ps-2">Profundidad: 1,40 m uniforme</div>
                  <div class="card border-0 ps-2">Volumen: 15.550 L</div>
                </div>
              </div>
              <div>
                <img src={PerlaIlustracion} class="card-img-top" alt="Ágata Ilustración" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 w-100">
        <div class="row m-1">

          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Gema Azul</h4>
              {/*<img src="/static/media/Gema Azul.a798bf5140ad21e6e8cb.jpg" class="card-img-top px-3" alt="Gema Azul" />*/}
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,30 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,55 m</div>
                  <div class="card ps-2">Profundidad: 1,40 a 1.60 m</div>
                  <div class="card border-0 ps-2">Volumen: 25.510 L</div>
                </div>
              </div>
              <div>
                <img src={GemaAzulIlustracion} class="card-img-top" alt="Gema Azul Ilustración" />
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Ópalo</h4>
              {/*<img src="/static/media/Opalo_ilustracion-transformed.2dd11744d4a83abcfd9c.png" class="card-img-top px-3" alt="Ópalo" />*/}
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,30 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,40 m</div>
                  <div class="card ps-2">Profundidad: 1,40 a 1,55 m</div>
                  <div class="card border-0 ps-2">Volumen: 24.520 L</div>
                </div>
              </div>
              <div>
                <img src={OpaloIlustracion} class="card-img-top" alt="Ópalo Ilustración" />
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-4">
            <div class="card mt-3" id="border">
              <h4 class="card-title text-center pt-2">Coral</h4>
              {/*<img src="/static/media/Coral_ilustracion-transformed.73c2d4277d395b883e7a.png" class="card-img-top px-3" alt="Coral" />*/}
              <div class="card-body">
                <div class="card p-1" id="border">
                  <h6 class="ps-1 fw-bold">Medidas</h6>
                  <div class="card ps-2">Largo: 7,0 m</div>
                  <div class="card border-0 ps-2">Ancho: 3,10 m</div>
                  <div class="card ps-2">Profundidad: 1,40 m</div>
                  <div class="card border-0 ps-2">Volumen: 20.650 L</div>
                </div>
              </div>
              <div>
                <img src={CoralIlustracion} class="card-img-top" alt="Coral Ilustración" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 w-100">
        <div class="row m-1">
       
        </div>
      </div>
    </>
  );
}

export default ModelosMedianos;
